import { writable } from 'svelte/store';
const previewAreaLoadingStore = writable(false);
export default previewAreaLoadingStore;
